<div class="header-title-section-labels">
    <core-title-section [title]="text" [breadcrumbs]="breadcrumbs" [description]="description"></core-title-section>
    <div class="labels-header-container">
        <core-labels-text [labels]="labels"></core-labels-text>
    </div>
</div>
